import { Controller } from '@hotwired/stimulus'
import Litepicker from 'litepicker';
import 'litepicker/dist/plugins/ranges';

export default class extends Controller {

  static targets = ['datepicker']

  connect(){
    let element = this.datepickerTarget
    let value = element.value
    const picker = new Litepicker({
      element: element,
      plugins: ['ranges'],
      format: 'DD/MM/YYYY',
      lang: 'fr',
      ranges: {
        customRangesLabels: ["Aujourd'hui", 'Hier', '7 derniers jours', '30 derniers jours', 'Mois en cours', 'Mois dernier']
      },
    });
    element.value = value
  }
}
